import classNames from 'classnames';
import React, { memo } from 'react';
import { type DirectionIndicatorProps } from './SVG.types';

const DirectionIndicator: React.FC<DirectionIndicatorProps> = memo(
  ({ className, direction = 'down', height = '20px', width = '20px', color = '' }) => {
    const combinedClass = classNames('icon icon-direction-indicator', className);

    const style: any = {};

    switch (direction) {
      case 'left':
        style.transform = 'rotate(90deg)';
        break;

      case 'right':
        style.transform = 'rotate(270deg)';
        break;

      case 'up':
        style.transform = 'rotate(180deg)';
        break;

      default:
        break;
    }

    return (
      <svg
        aria-hidden="true"
        className={combinedClass}
        focusable="false"
        height={height}
        style={style}
        version="1.1"
        viewBox="0 0 20 20"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path
          d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
          fill={color}
        />
      </svg>
    );
  },
);

// Display Name
DirectionIndicator.displayName = 'DirectionIndicator';

export default DirectionIndicator;
